namespace GeniuzPOS {
    export interface ScriptUserDefinition {
        Username?: string;
        DisplayName?: string;
        IsAdmin?: boolean;
        ShopId?: string;
        UserId?: number;
        Permissions?: { [key: string]: boolean };
    }
}
